export default __webpack_public_path__ + "static/media/step5.b8cd488b.png";